export default "__VITE_ASSET__582f0475__"